module.exports = __webpack_public_path__ + "media/images/reports-59f37a680b21892eb7f2015eab98b485.svg";